import { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';

import useCurrentLocale from './useCurrentLocale';
import useIsMounted from 'hooks/useIsMounted';
import { GO_SCREVER, APP_SCREVER } from 'constants/urls';

const useGoScreverTemplateData = (TEMPLATE_ID) => {
  const [_templateData, setTemplateData] = useState(null);
  const { currentLocale } = useCurrentLocale();

  const isMounted = useIsMounted();

  // получаем темплейт по id
  const getTemlate = useCallback(async () => {
    if (!TEMPLATE_ID) return;

    try {
      const { data } = await axios(
        `${APP_SCREVER}/api/v1/surveys/${TEMPLATE_ID}/public-template`
      );

      const {
        data: { link },
      } = await axios(
        `${APP_SCREVER}/api/v1/surveys/${TEMPLATE_ID}/public-template-link`
      );

      if (!isMounted()) return;

      setTemplateData({
        data,
        link,
      });
    } catch (error) {}
  }, [TEMPLATE_ID, isMounted]);

  useEffect(() => {
    getTemlate();
  }, [getTemlate, TEMPLATE_ID]);
  // получаем темплейт по id

  return useMemo(() => {
    if (!_templateData) return {};

    const {
      data: {
        name,
        description,
        // TODO: no data sent
        previewScreenShot: { url: preview },
        defaultLanguage,
        tagEntities,
        questionsCount,
        approximateTime,
      },
      link,
    } = _templateData;

    return {
      defaultLocale: new Intl.DisplayNames(currentLocale, {
        type: 'language',
        languageDisplay: 'standard',
      }).of(defaultLanguage || currentLocale),
      name: name[currentLocale] || name[defaultLanguage],
      description: description[currentLocale] || description[defaultLanguage],
      preview,
      tag: tagEntities[0]?.tag.name || '',
      link: link ?? GO_SCREVER,
      questionsCount: questionsCount ?? 0,
      approximateTime: approximateTime ?? 0,
    };
  }, [_templateData, currentLocale]);
};

export default useGoScreverTemplateData;
